// extracted by mini-css-extract-plugin
var _1 = "IdwellToIdwellRequestTableRow-moduleIdwellToIdwellRequestTableRow__JCMyC TableComponent-modulerow__xPAo4";
export { _1 as "IdwellToIdwellRequestTableRow" }
